import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import Detail from './components/Detail';
import useColumns from './hooks/useColumns';
import useHistoryMt from './hooks/useHistoryMt';
import { styTable, styWrapper } from './style';

/**
 * @typedef {import('@services/api/stock/history/margin').HistoryMt} HistoryMt
 * @typedef {import('@ajaibid/components').TableProps<HistoryMt>['getRowId']} GetRowId
 */

/**
 * @type {GetRowId}
 */
function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.idx_trade_no || ix}`;
}

function renderRowExpand(row) {
  return <Detail item={row.original} />;
}

const StockHistoryMT = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useHistoryMt();

  const columns = useColumns();

  useImperativeHandle(ref, () => ({
    // Allow the following functions & variables to be called from its parents
    refetchTable: refetch,
    isRefetching: isRefetching,
  }));

  return (
    <div className={styWrapper}>
      <Table
        className={styTable}
        data={data}
        columns={columns}
        options={{ isHeaderVisible: true, isRowExpandable: true }}
        fetchNext={fetchNextPage}
        getRowId={getRowId}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNextPage}
        renderRowExpand={renderRowExpand}
        emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
      />
    </div>
  );
});

export default StockHistoryMT;
